import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS } from '@angular/material/core';

const FORMATS = {
    parse: {
        dateInput: 'YYYY-MM-DD'
    },
    display: {
        dateInput: 'YYYY-MM-DD',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    }
};

/** Component for setting filters on the plot data */
@Component({
    selector: 'sci-datepicker-utc-yyyymmdd',
    template: `
    <mat-form-field appearance="outline">
        <mat-label>{{label}}</mat-label>
        <input matInput [matDatepicker]="picker" [formControl]="date" required>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>`,
    providers: [
        { provide: MAT_DATE_FORMATS, useValue: FORMATS },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
    ]
})
export class DatepickerUTCComponent {
    @Input() label: string;
    @Input() date: FormControl;
}
